// Shared Socket.io client singleton. Path must match the backend mount (/api/socket.io).
import { io } from "socket.io-client";

let socket = null;

export function getSocket() {
  if (!socket) {
    socket = io(process.env.REACT_APP_BACKEND_URL, {
      path: "/api/socket.io",
      transports: ["polling", "websocket"],
      autoConnect: true,
    });
  }
  return socket;
}
